export default {
    /**
     * Get all accounts & currency for corp
     * 
     * @returns {Promise}
     */
    getImportForm() {
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.get(`/rest/bankreconciliation/import/form`, {}, (response) => {
                resolve(response)
            },
            (error) => {
                reject(error.response.data.error.message)
            });
        })
    },

    /**
     * Upload csv to server in formData
     * @param formData
     * @returns {Promise}
     */
    upload(formData){
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.post('/rest/bankreconciliation/import/upload', {}, formData, 
            (response) => {
                resolve(response)
            },
            (error) => {
                reject(error.response.data.error.message)
            });
        })
    },

    /**
     * Get config for import
     * @param {Number} importId
     * @returns {Promise}
     */
    getConfig(importId){
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.get(`/rest/bankreconciliation/import/${importId}/config`, {}, 
            (response) => {
                resolve(response)
            },
            (error) => {
                reject(error.response.data.error.message)
            });
        })
    },

    /**
     * Update config for import
     * @param {Number} importId
     * @param {Object} payload
     * @returns {Promise}
     */
    updateConfig(importId, payload){
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.post(`/rest/bankreconciliation/import/${importId}/config`, {}, payload,
            (response) => {
                resolve(response)
            },
            (error) => {
                reject(error.response.data.error.message)
            });
        })
    },

    /**
     * Get template for import
     * @param {Number} importId
     * @returns {Promise}
     */
    getTemplate(importId) {
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.get(`/rest/bankreconciliation/import/${importId}/template`, {},
                (response) => {
                    resolve(response)
                },
                (error) => {
                    reject(error.response.data.error.message)
                });
        })
    },

    /**
    * Update template for import
    * @param {Number} importId
    * @param {Object} payload
    * @returns {Promise}
    */
    updateTemplate(importId, payload){
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.post(`/rest/bankreconciliation/import/${importId}/template`, {}, payload,
            (response) => {
                resolve(response)
            },
            (error) => {
                reject(error.response.data.error.message)
            });
        })
    },

    /**
     * Get preview for import
     * @param {Number} importId
     * @returns {Promise}
     */
    getPreview(importId){
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.get(`/rest/bankreconciliation/import/${importId}/preview`, {},
                (response) => {
                    resolve(response)
                },
                (error) => {
                    reject(error.response.data.error.message)
                });
        })
    },

    /**
     * process import
     * @param {Number} importId
     * @returns {Promise}
     */
    process(importId) {
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.post(`/rest/bankreconciliation/import/${importId}/process`, {}, {},
                (response) => {
                    resolve(response)
                },
                (error) => {
                    reject(error.response.data.error.message)
                });
        })
    },

    /**
     * Launch transaction transfer
     * @param {Object} data 
     */
    transferTransaction(data) {
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.post(`rest/bankreconciliation/transactions/transfer`, {}, data, 
                (response) => {
                    resolve(response)
                },
                (error) => {
                    reject(error.response.data.error.details)
                }
            );
        })
    },
    
    getBankAccounts() {
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.get('rest/bankreconciliation/accounts', {}, (response) => {
                resolve(response);
            }, (error) => {
                reject(error.response.data.error.message)
            });
        })
    }
}